import React, { useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route, useLocation } from 'react-router-dom';
import { CartProvider } from './context/CartContext';
import { Header } from './components/Header';
import { Footer } from './components/Footer';
import { HomePage } from './pages/HomePage';
import { ProductPage } from './pages/ProductPage';
import { CartPage } from './pages/CartPage';
import { ThankYouPage } from './pages/ThankYouPage';
// ScrollToTop component to handle scroll restoration on route change
function ScrollToTop() {
  const {
    pathname
  } = useLocation();
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);
  return null;
}
export default function App() {
  return <CartProvider data-id="element-0">
      <Router data-id="element-1">
        <ScrollToTop data-id="element-2" />{' '}
        {/* Manual scroll handling if ScrollRestoration doesn't work in some envs */}
        <div className="flex flex-col min-h-screen bg-white font-sans text-gray-900" data-id="element-3">
          <Header data-id="element-4" />
          <Routes data-id="element-5">
            <Route path="/" element={<HomePage data-id="element-7" />} data-id="element-6" />
            <Route path="/product/:id" element={<ProductPage data-id="element-9" />} data-id="element-8" />
            <Route path="/cart" element={<CartPage data-id="element-11" />} data-id="element-10" />
            <Route path="/thank-you" element={<ThankYouPage data-id="element-13" />} data-id="element-12" />
          </Routes>
          <Footer data-id="element-14" />
        </div>
      </Router>
    </CartProvider>;
}